// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: GacsviuonU_
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import Sidebar from "../../Sidebar"; // plasmic-import: KsLZ7sb8Ji8/component
import TopBar from "../../TopBar"; // plasmic-import: MnkTdPJ0xv/component
import DashboardPaymentsCard from "../../DashboardPaymentsCard"; // plasmic-import: sAZglV6OPm/component
import DashboardContractsCard from "../../DashboardContractsCard"; // plasmic-import: al9pdEgoxc/component
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicDashboardPlasmic2TestingFormatIdea2.module.css"; // plasmic-import: GacsviuonU_/css

export const PlasmicDashboardPlasmic2TestingFormatIdea2__VariantProps =
  new Array();

export const PlasmicDashboardPlasmic2TestingFormatIdea2__ArgProps = new Array();

function PlasmicDashboardPlasmic2TestingFormatIdea2__RenderFunc(props) {
  const { variants, args, overrides, forNode } = props;
  const $props = props.args;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div className={classNames(projectcss.all, sty.freeBox__o4V8X)}>
            {true ? (
              <TopBar
                className={classNames("__wab_instance", sty.topBar__gpwZn)}
              />
            ) : null}

            <TopBar
              className={classNames("__wab_instance", sty.topBar__uqOz)}
              userNameText={"Jones Ferdinand"}
            />

            <div
              data-plasmic-name={"sheet"}
              data-plasmic-override={overrides.sheet}
              className={classNames(projectcss.all, sty.sheet)}
            >
              <div
                data-plasmic-name={"graphStack"}
                data-plasmic-override={overrides.graphStack}
                className={classNames(projectcss.all, sty.graphStack)}
              />

              <p.Stack
                as={"div"}
                data-plasmic-name={"figmaPaste2"}
                data-plasmic-override={overrides.figmaPaste2}
                hasGap={true}
                className={classNames(projectcss.all, sty.figmaPaste2)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__nE3Ae
                  )}
                >
                  {"Account Balance"}
                </div>

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__gUZx
                  )}
                >
                  {"$0.00"}
                </div>

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__ksGaZ
                  )}
                >
                  {"Escrow Balance"}
                </div>

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___5MlV
                  )}
                >
                  {"$0.00"}
                </div>

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__cjOaK
                  )}
                >
                  {"Payouts"}
                </div>

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__nTpqi
                  )}
                >
                  {"$0.00"}
                </div>
              </p.Stack>
            </div>

            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__c7KmL)}
            >
              <div
                data-plasmic-name={"unresolvedTickets"}
                data-plasmic-override={overrides.unresolvedTickets}
                className={classNames(projectcss.all, sty.unresolvedTickets)}
              >
                <div
                  data-plasmic-name={"cardsDefault"}
                  data-plasmic-override={overrides.cardsDefault}
                  className={classNames(projectcss.all, sty.cardsDefault)}
                >
                  <div
                    data-plasmic-name={"sheet2"}
                    data-plasmic-override={overrides.sheet2}
                    className={classNames(projectcss.all, sty.sheet2)}
                  >
                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(projectcss.all, sty.freeBox__kzWen)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text___6KqyO
                        )}
                      >
                        {"Payments"}
                      </div>

                      <div
                        data-plasmic-name={"viewDetails"}
                        data-plasmic-override={overrides.viewDetails}
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.viewDetails
                        )}
                      >
                        {"View All"}
                      </div>
                    </p.Stack>

                    <DashboardPaymentsCard
                      data-plasmic-name={"dashboardPaymentsCard"}
                      data-plasmic-override={overrides.dashboardPaymentsCard}
                      className={classNames(
                        "__wab_instance",
                        sty.dashboardPaymentsCard
                      )}
                    />
                  </div>
                </div>
              </div>

              <div
                data-plasmic-name={"unresolvedTickets2"}
                data-plasmic-override={overrides.unresolvedTickets2}
                className={classNames(projectcss.all, sty.unresolvedTickets2)}
              >
                <div
                  data-plasmic-name={"cardsDefault2"}
                  data-plasmic-override={overrides.cardsDefault2}
                  className={classNames(projectcss.all, sty.cardsDefault2)}
                >
                  <div
                    data-plasmic-name={"sheet3"}
                    data-plasmic-override={overrides.sheet3}
                    className={classNames(projectcss.all, sty.sheet3)}
                  >
                    <p.Stack
                      as={"div"}
                      hasGap={true}
                      className={classNames(projectcss.all, sty.freeBox__sli7K)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__buLt5
                        )}
                      >
                        {"Contracts"}
                      </div>

                      <div
                        data-plasmic-name={"viewDetails2"}
                        data-plasmic-override={overrides.viewDetails2}
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.viewDetails2
                        )}
                      >
                        {"View All"}
                      </div>
                    </p.Stack>

                    <DashboardContractsCard
                      data-plasmic-name={"dashboardContractsCard"}
                      data-plasmic-override={overrides.dashboardContractsCard}
                      className={classNames(
                        "__wab_instance",
                        sty.dashboardContractsCard
                      )}
                    />
                  </div>
                </div>
              </div>
            </p.Stack>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "sheet",
    "graphStack",
    "figmaPaste2",
    "unresolvedTickets",
    "cardsDefault",
    "sheet2",
    "viewDetails",
    "dashboardPaymentsCard",
    "unresolvedTickets2",
    "cardsDefault2",
    "sheet3",
    "viewDetails2",
    "dashboardContractsCard"
  ],

  sidebar: ["sidebar"],
  sheet: ["sheet", "graphStack", "figmaPaste2"],
  graphStack: ["graphStack"],
  figmaPaste2: ["figmaPaste2"],
  unresolvedTickets: [
    "unresolvedTickets",
    "cardsDefault",
    "sheet2",
    "viewDetails",
    "dashboardPaymentsCard"
  ],

  cardsDefault: [
    "cardsDefault",
    "sheet2",
    "viewDetails",
    "dashboardPaymentsCard"
  ],

  sheet2: ["sheet2", "viewDetails", "dashboardPaymentsCard"],
  viewDetails: ["viewDetails"],
  dashboardPaymentsCard: ["dashboardPaymentsCard"],
  unresolvedTickets2: [
    "unresolvedTickets2",
    "cardsDefault2",
    "sheet3",
    "viewDetails2",
    "dashboardContractsCard"
  ],

  cardsDefault2: [
    "cardsDefault2",
    "sheet3",
    "viewDetails2",
    "dashboardContractsCard"
  ],

  sheet3: ["sheet3", "viewDetails2", "dashboardContractsCard"],
  viewDetails2: ["viewDetails2"],
  dashboardContractsCard: ["dashboardContractsCard"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = deriveRenderOpts(props, {
      name: nodeName,
      descendantNames: [...PlasmicDescendants[nodeName]],
      internalArgPropNames:
        PlasmicDashboardPlasmic2TestingFormatIdea2__ArgProps,
      internalVariantPropNames:
        PlasmicDashboardPlasmic2TestingFormatIdea2__VariantProps
    });

    return PlasmicDashboardPlasmic2TestingFormatIdea2__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDashboardPlasmic2TestingFormatIdea2";
  } else {
    func.displayName = `PlasmicDashboardPlasmic2TestingFormatIdea2.${nodeName}`;
  }
  return func;
}

export const PlasmicDashboardPlasmic2TestingFormatIdea2 = Object.assign(
  // Top-level PlasmicDashboardPlasmic2TestingFormatIdea2 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    sheet: makeNodeComponent("sheet"),
    graphStack: makeNodeComponent("graphStack"),
    figmaPaste2: makeNodeComponent("figmaPaste2"),
    unresolvedTickets: makeNodeComponent("unresolvedTickets"),
    cardsDefault: makeNodeComponent("cardsDefault"),
    sheet2: makeNodeComponent("sheet2"),
    viewDetails: makeNodeComponent("viewDetails"),
    dashboardPaymentsCard: makeNodeComponent("dashboardPaymentsCard"),
    unresolvedTickets2: makeNodeComponent("unresolvedTickets2"),
    cardsDefault2: makeNodeComponent("cardsDefault2"),
    sheet3: makeNodeComponent("sheet3"),
    viewDetails2: makeNodeComponent("viewDetails2"),
    dashboardContractsCard: makeNodeComponent("dashboardContractsCard"),
    // Metadata about props expected for PlasmicDashboardPlasmic2TestingFormatIdea2
    internalVariantProps:
      PlasmicDashboardPlasmic2TestingFormatIdea2__VariantProps,
    internalArgProps: PlasmicDashboardPlasmic2TestingFormatIdea2__ArgProps
  }
);

export default PlasmicDashboardPlasmic2TestingFormatIdea2;
/* prettier-ignore-end */
